import InputBox from '../../component/InputBox';
import { modalType, convertModalType } from '../../util/ModalUtil';
import { useRef, useState } from 'react';
import { InfoTxt, ModalHeader } from '../../component/ModalRef';

import { useDispatch } from 'react-redux';
import { actionCodeGroupAdd, actionCodeGroupEdit } from '../../module/body/system/SystemCommonCodeModule';
import PopupRef from '../../component/PopupRef';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';

/* 모달을 닫기 위해서 modalRef를 반드시 전달받아야 함 */
const CodeGroupModal = ({ type, row, modalRef }) => {
    const dispatch = useDispatch();
    const [cdGrpId, setGrpId] = useState(row && row.cdGrpId);
    const [cdGrpNm, setGrpNm] = useState(row && row.cdGrpNm);

    const popupRef = useRef(null);

    const handleCancel = () => {
        modalRef.current.close();
    };

    const handleConfirm = () => {
        if (cdGrpId == undefined || cdGrpId == null || cdGrpId == '') {
            popupRef.current.openAlert('코드그룹ID를 입력하세요.');
        } else if (cdGrpNm == undefined || cdGrpNm == null || cdGrpNm == '') {
            popupRef.current.openAlert('코드그룹명을 입력하세요.');
        } else {
            if (type == modalType.ADD) {
                dispatch(actionCodeGroupAdd({ cdGrpId, cdGrpNm }));
            } else {
                dispatch(actionCodeGroupEdit({ cdGrpId, cdGrpNm }));
            }
            modalRef.current.close();
        }
    };

    return (
        <>
            <ModalHeader title={'코드그룹 ' + convertModalType(type)} modalRef={modalRef} />
            <div className='modal-body'>
                <div className='con-inner CodeGroupModal'>
                    <InfoTxt
                        infoTxt={type == modalType.ADD ? '코드그룹 정보를 등록합니다.' : '코드그룹 정보를 수정합니다.'}
                    />
                    <div className='form-box-row'>
                        <InputBox
                            title='코드그룹ID'
                            disabled={type != modalType.ADD}
                            value={cdGrpId}
                            onChange={(e) => setGrpId(e.target.value)}
                        />
                    </div>
                    <div className='form-box-row'>
                        <InputBox title='코드그룹명' value={cdGrpNm} onChange={(e) => setGrpNm(e.target.value)} />
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    <CancelButtonBox title='취소' onClick={() => handleCancel()} />
                    <ConfirmButtonBox title='확인' onClick={() => handleConfirm()} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default CodeGroupModal;
